import { IconDefinition } from '@fortawesome/fontawesome-svg-core';
import { faFileShield, faRobot, faScaleBalanced, faUserShield } from '@fortawesome/free-solid-svg-icons';
import { CUSTOMER_POLICIES_LAST_UPDATED, PRIVACY_LAST_UPDATED, TERMS_LAST_UPDATED } from './meta';
import { AI_HEALTH_TERMS } from './aiHealthTerms';

export interface LegalDocumentEntry {
  slug: string;
  route: string;
  title: string;
  summary: string;
  lastUpdated: string;
  version: string;
  icon: IconDefinition;
  iconClass: string;
}

export const LEGAL_DOCUMENTS: LegalDocumentEntry[] = [
  {
    slug: 'terms-and-conditions',
    route: '/terms',
    title: 'Terms of Use',
    summary:
      'The rules governing your use of the Infinicare Platform: eligibility, account security, health data usage, payments, intellectual property, liability and termination.',
    lastUpdated: TERMS_LAST_UPDATED,
    version: '1.0',
    icon: faScaleBalanced,
    iconClass: 'lg-icon-navy',
  },
  {
    slug: 'privacy-policy',
    route: '/privacy-policy',
    title: 'Privacy Policy',
    summary:
      'What information we collect, how we use and share it, how long we keep it, how it is secured, and the rights you can exercise over your personal data.',
    lastUpdated: PRIVACY_LAST_UPDATED,
    version: '1.0',
    icon: faUserShield,
    iconClass: 'lg-icon-cyan',
  },
  {
    slug: 'customer-policies',
    route: '/customer-policies',
    title: 'Service Policies',
    summary:
      'The policies behind our Terms of Use and Privacy Policy: refunds and cancellations, disputes, payments and chargebacks, information security, DPDP, GDPR, CCPA, HIPAA, insurance arrangements and customer responsibilities.',
    lastUpdated: CUSTOMER_POLICIES_LAST_UPDATED,
    version: '1.0',
    icon: faFileShield,
    iconClass: 'lg-icon-green',
  },
  {
    slug: 'ai-health-terms',
    route: '/ai-health-terms',
    title: 'AI & Health Insights Terms',
    summary:
      'The extra terms for our automated features — AI Family Doctor, Health Assessment, Health Insights and Disease Prediction: what they read, what they cannot do, and the limits on both sides.',
    lastUpdated: AI_HEALTH_TERMS.lastUpdated,
    version: AI_HEALTH_TERMS.version,
    icon: faRobot,
    iconClass: 'lg-icon-indigo',
  },
];

export { CUSTOMER_POLICIES } from './customerPolicies';
export { AI_HEALTH_TERMS } from './aiHealthTerms';
export type {
  LegalBlock,
  LegalContact,
  LegalContactItem,
  LegalDocument,
  LegalSection,
} from './types';
